<template>
    <div v-loading="loading">
        <Record14Record
            :obj="dataRecord"
            :type="'1'"
            @clickAdd="addCallback"
            v-if="null != dataRecord"
        />
    </div>
</template>

<script setup>

import Record14Record from "@/components/shopopee/hall/record14Record.vue";
import {inject, ref, onBeforeMount, toRef} from "vue";
import record15Api from "@/request/record15Api";
import myUtil from "@/util/util";
import {useUserinfo} from "@/stores/userinfo";
import {usePageinfo} from "@/stores/pageinfo";

const props = defineProps(["mallId"])
const emits = defineEmits(["save-complete"])

const i18n = inject("i18n")
const loading = ref(false)

const userInfoRef = toRef(useUserinfo())
const pageInfoRef = toRef(usePageinfo())

const dataRecord = ref(null)

function getHallObj(){
    loading.value = true

    const request = record15Api.queryRecord14CompanyModelByPage
    const params = request.getParams()

    params.id = props.mallId
    params.addinfo17 = "1"
    params.pageNum = 1
    params.pageSize = 1

    request.send(params, (res) => {
        loading.value = false
        const obj = res.detail

        if (null != obj && obj.total > 0){
            dataRecord.value = obj.list[0]
        }

    })

}

function addCallback(){
    loading.value = true
    const request = record15Api.submitRecord15
    const params = request.getParams()

    params.additionalrecord15.companycode = userInfoRef.value.companycode
    params.additionalrecord15.login = userInfoRef.value.id
    params.additionalrecord15.updatedid = dataRecord.value.id
    params.additionalrecord15.addinfo12 = "{}"
    params.additionalrecord15.addinfo13 = "1"

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            myUtil.alertSuccess(i18n.tkey("lang_submit_record_already"))
            emits("save-complete")
        }else if (res.code == 201){
            myUtil.alertWarning(i18n.tkey("lang_applied_warning"))
        }else{
            myUtil.alertError(res.msg)
        }
    })
}

onBeforeMount(() => {
    if (null != props.mallId){
        getHallObj()
    }
})

</script>

<style scoped>

</style>